import { Logo } from "./Shared";

export const Disclosure = () => (
  <footer className="bg-[var(--cream)] px-5 pb-10 pt-14 sm:px-8 lg:px-14" data-testid="site-footer">
    <div className="mx-auto max-w-4xl">
      <div className="space-y-4 rounded-2xl border border-[var(--blush-deep)] bg-white p-6 text-sm leading-relaxed text-[var(--muted)] sm:p-8 sm:text-[0.95rem]" data-testid="disclosure-block">
        <p data-testid="affiliate-disclosure">
          <strong className="text-[var(--ink)]">Affiliate disclosure:</strong> I may earn a commission if you purchase The Boss Suite through my link, at no additional cost to you.
        </p>
        <p data-testid="earnings-disclaimer">
          <strong className="text-[var(--ink)]">Earnings disclaimer:</strong> My first-week result of $300 reflects my personal experience and is not typical or guaranteed. Your results may differ. Income from online business activities depends on factors including your effort, skills, audience, chosen methods, and market conditions.
        </p>
      </div>
      <div className="mt-10 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <Logo />
        <p className="text-sm text-[var(--muted)]">© {new Date().getFullYear()} itsmeharleeey</p>
      </div>
    </div>
  </footer>
);
